import { Pipe, PipeTransform } from '@angular/core';

type IconType = 'svg' | 'fa5' | 'fa6' | 'custom' | 'none';

@Pipe({
  name: 'iconType',
  standalone: true,
})
export class IconTypePipe implements PipeTransform {
  transform(name: string): unknown {
    if(!name)
      return 'none'
    if (name.startsWith('fas fa-') || name.startsWith('far fa-') || name.startsWith('fal fa-') || name.startsWith('fad fa-') || name.startsWith('fab fa-'))
      return 'fa5';
    if (name.startsWith('fa-'))
      return 'fa6';
    if (name.startsWith('<svg'))
      return 'svg';
    return 'custom';
  }
}
